import { apiGet } from '../_common';

export default {
  schema() {
    return apiGet('/magenta/stock/product/trait/schema').then(result => result.response);
  },
};
